import React from 'react'
import UiplusService from '../Components/UiplusService'
import PageHero from '../Components/PageHero'



function OurServices() {
  return (
    <>
      <div className="row mt-5"></div>
      
      <PageHero 
       title="Our Services"
       subtitle="We provide smart IT solutions"
      />
    
      <UiplusService />
    </>
  )
}

export default OurServices
